import {apiClient} from "./api-client";
import type {components} from "./api-types";

// ============================================================================
// Types - re-exported from generated OpenAPI types
// ============================================================================

export type SentimentPost = components["schemas"]["InfegySentimentPost"];
export type SentimentInfluencerWithPosts = components["schemas"]["InfegySentimentAccountWithPosts"];

// ============================================================================
// API Functions
// ============================================================================

export async function fetchSentimentInfluencers(
  locationId: string,
  signal?: AbortSignal
): Promise<SentimentInfluencerWithPosts[]> {
  const {data, error} = await apiClient.GET("/api/infegy/sentiment-accounts", {
    params: {
      query: {location_id: locationId},
    },
    signal,
  });

  if (error || !data) {
    throw new Error(
      (error as {detail?: string})?.detail || "Failed to fetch sentiment influencers"
    );
  }

  return data;
}

// ============================================================================
// Utility Functions
// ============================================================================

/**
 * Format a number with K/M suffixes for display
 * @example formatMetricNumber(1500) => "1.5K"
 * @example formatMetricNumber(1500000) => "1.5M"
 */
export function formatMetricNumber(num: number | null | undefined): string {
  if (num === null || num === undefined || num === 0) return "0";

  return new Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(num);
}

// ============================================================================
// Metric Configuration (for charts)
// ============================================================================

export const INFLUENCER_METRICS = [
  {key: "combined_influence_score", label: "Score"},
  {key: "followers", label: "Followers"},
  {key: "total_engagements", label: "Engagement"},
  {key: "total_likes", label: "Likes"},
  {key: "total_shares", label: "Shares"},
  {key: "total_comments", label: "Comments"},
] as const;

export type InfluencerMetricKey = (typeof INFLUENCER_METRICS)[number]["key"];

export const METRIC_CHART_COLORS = [
  "from-blue-400/30 to-blue-400",
  "from-green-400/30 to-green-400",
  "from-purple-400/30 to-purple-400",
  "from-orange-400/30 to-orange-400",
  "from-pink-400/30 to-pink-400",
  "from-cyan-400/30 to-cyan-400",
];
